import { useEffect, useState } from "react";
import axios from "axios";

import { API_URL } from "../constants/constants";
import { useAuth0 } from "../hooks/react-auth0-spa";

const useGuiasAPI = (initialBody = {}) => {
  // console.log(initialUser);
  // const [user, setUser] = useState(initialUser);
  const [body, setBody] = useState(initialBody);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { user, getTokenSilently } = useAuth0();

  useEffect(() => {
    if (Object.keys(body).length === 0) return;
    const fetchData = async () => {
      setIsError(false);
      setIsLoading(true);
      try {
        const t = await getTokenSilently();
        const r = await axios.post(API_URL + `/generar/${user.sub}`, body, {
          headers: {
            Authorization: `Bearer ${t}`,
          },
        });
        if (r.status === 206) {
          setIsError(true);
        } else {
          setIsError(false);
          setData(r.data);
        }
      } catch (error) {
        console.log(error);
        setIsError(true);
      }
      setIsLoading(false);
    };
    fetchData();
    // eslint-disable-next-line
  }, [body]);

  return [{ data, isLoading, isError }, setBody];
};

export default useGuiasAPI;
